import Drupal from "drupal";


(function($, Drupal) {
    /**
     * Initialize conditional field visibility for tile link grid cards
     * @param {jQuery} context - The context to search within
     */
    function initializeConditionalFields(context: JQuery) {
        $('.field--name-field-make-this-tile-a-modal-', context).each(function () {
            let $this = $(this);
            let $fieldToToggle = $this.closest('.paragraphs-subform').find('.field--name-field-link-list');
            let $input = $('select', $this);

            // Skip if already initialized
            if ($input.data('conditional-field-initialized')) {
                return;
            }

            // Set initial visibility based on current value
            $fieldToToggle.toggle($input.val() === 'Yes');

            // Change visibility on input change
            $input.on('change.conditionalField', function() {
                $fieldToToggle.toggle($input.val() === 'Yes');
            });

            // Mark as initialized
            $input.data('conditional-field-initialized', true);
        });
    }

    Drupal.behaviors.tileLinkGrid = {
        attach: function(context, settings) {
            // Initialize on page load
            initializeConditionalFields($(context));

            // Also initialize after AJAX requests (when adding new tiles)
            $(document).ajaxComplete(function(event, xhr, settings) {
                // Check if extraData is set
                if (typeof (settings as any).extraData === 'undefined') {
                    return;
                }
                if ((settings as any).extraData._triggering_element_name.startsWith('field_tiles_tile_link_grid_card_add_more')) {
                    // Use the context from the AJAX response
                    initializeConditionalFields($(context));
                }
            });
        }
    };
})(jQuery, Drupal);